__turbopack_context__.v({
  "Header": "Header-module-scss-module__6R4jra__Header",
  "Inner": "Header-module-scss-module__6R4jra__Inner",
  "IsOpen": "Header-module-scss-module__6R4jra__IsOpen",
  "Logo": "Header-module-scss-module__6R4jra__Logo",
  "SkipContent": "Header-module-scss-module__6R4jra__SkipContent",
});
